import { Injectable } from '@angular/core';
import { INotificationCategoryItem } from '@fi-shared/fi-notification/fi-notification';
import { PersonalNotificationsCategoryType } from '@fi-shared/types';

@Injectable()
export class FiNotificationHelperService {
    constructor() {}

    isSeen(item: INotificationCategoryItem) {
        return item.NotificationCategory >= PersonalNotificationsCategoryType.Seen;
    }
    isNotSeen(item: INotificationCategoryItem) {
        return !this.isSeen(item);
    }
    isVisited(item: INotificationCategoryItem) {
        return item.NotificationCategory >= PersonalNotificationsCategoryType.Visited;
    }
    isNotVisited(item: INotificationCategoryItem) {
        return !this.isVisited(item);
    }
    setIsSeen(item: INotificationCategoryItem) {
        if (this.isNotSeen(item)) {
            item.NotificationCategory = PersonalNotificationsCategoryType.Seen;
        }
    }
    setIsVisited(item: INotificationCategoryItem) {
        if (this.isNotVisited(item)) {
            item.NotificationCategory = PersonalNotificationsCategoryType.Visited;
        }
    }
}
